module.exports = __webpack_public_path__ + "img/customer-page.704d0035.png";